import eCreditFetch from './acc_interceptor.ts';
import ServiceResponse from "@/types_and_interfaces/service_response_interface.ts";
import API_CLS from "@/utils/api.ts";
import * as Sentry from "@sentry/react";


export const calculator = () => {
    const get_limits = async () => {
        let response:ServiceResponse = {
            error: false,
        };
        
        try {
            
            const request = await eCreditFetch(API_CLS.calculator.get_limits, {
                method: API_CLS.methods.Get,
            });
            
            response.status = request?.status
            const body = await request?.json();
            
            if(response.status === 200) {
                response.response = body
                
            } else {
                response.error = true
                response.message = "error_message"
            }
            
            return response;
            
        } catch (error) {
            Sentry.captureException(error, { tags: { section: "calculator", action: "get_limits" } });
            response.error = true;

            return response;
        }
    }

    const get_products = async (months:string, capital:string, category_id:string) => {
        let response:ServiceResponse = {
            error: false,
        };
        
        try {
            
            const request = await eCreditFetch(`${API_CLS.calculator.get_products}/${months}/${capital}/${category_id}`, {
                method: API_CLS.methods.Get,

            });
            
            response.status = request?.status
            const body = await request?.json();
            
            if(response.status === 200) {
                response.response = body.data
                
            } else {
                response.error = true
                response.message = "error_message"
            }
            
            return response;
            
        } catch (error) {
            Sentry.captureException(error, { tags: { section: "calculator", action: "get_products" } });
            response.error = true;

            return response;
        }
    }

    return {
        get_limits,
        get_products
    }
}